<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item label="订单号，唯一" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['orderCode', validatorRules.orderCode]" placeholder="请输入订单号，唯一"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="医生ID" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['doctorId', validatorRules.doctorId]" placeholder="请输入医生ID"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="患者ID" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['patientId', validatorRules.patientId]" placeholder="请输入患者ID"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="第三方订单号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['thirdOrderCode']" placeholder="请输入第三方订单号"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="支付金额，单位分" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['amount', validatorRules.amount]" placeholder="请输入支付金额，单位分" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="支付完成时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date placeholder="请选择支付完成时间" v-decorator="['endPayTime']" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="开始支付时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date placeholder="请选择开始支付时间" v-decorator="['startPayTime']" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="订单状态 0 未支付  1支付成功 2支付失败 3 已退款" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['status', validatorRules.status]" placeholder="请输入订单状态 0 未支付  1支付成功 2支付失败 3 已退款" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="商品类型  1，医生图文消息  2，医生视频消息" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['shopType', validatorRules.shopType]" placeholder="请输入商品类型  1，医生图文消息  2，医生视频消息" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="创建时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date placeholder="请选择创建时间" v-decorator="['createTime', validatorRules.createTime]" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">提 交</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@comp/jeecg/JFormContainer'
  import JDate from '@comp/jeecg/JDate'

  export default {
    name: 'OrderForm',
    components: {
      JFormContainer,
      JDate,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
validatorRules: {
        orderCode: {
        rules: [
            { required: true, message: '请输入订单号，唯一!'},
        ]
        },
        doctorId: {
        rules: [
            { required: true, message: '请输入医生ID!'},
        ]
        },
        patientId: {
        rules: [
            { required: true, message: '请输入患者ID!'},
        ]
        },
        amount: {
        rules: [
            { required: true, message: '请输入支付金额，单位分!'},
        ]
        },
        status: {
        rules: [
            { required: true, message: '请输入订单状态 0 未支付  1支付成功 2支付失败 3 已退款!'},
        ]
        },
        shopType: {
        rules: [
            { required: true, message: '请输入商品类型  1，医生图文消息  2，医生视频消息!'},
        ]
        },
        createTime: {
        rules: [
            { required: true, message: '请输入创建时间!'},
        ]
        },
},
        url: {
          add: "/order/order/add",
          edit: "/order/order/edit",
          queryById: "/order/order/queryById"
        }
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'orderCode','doctorId','patientId','thirdOrderCode','amount','endPayTime','startPayTime','status','shopType','createTime'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'orderCode','doctorId','patientId','thirdOrderCode','amount','endPayTime','startPayTime','status','shopType','createTime'))
      },
    }
  }
</script>